import moment from "moment";

export const transformAdidRequests = (data) => {
  const {content = []} = data;

  const out = []

  content?.forEach(item => {
    const req = {
      id: item.id,
      msisdn: item?.phone,
      createdDate: item?.createdDate,
    };
    const [lookupRequestItem] = item?.lookupRequestItems;
    if (lookupRequestItem) {
      req.status = lookupRequestItem?.dataStatus;
      req.dataStatus = lookupRequestItem?.status;
      req.errorReason = lookupRequestItem?.errorReason;

      if (lookupRequestItem?.responseItems?.length > 0) {
        const [responseItem] = lookupRequestItem?.responseItems;
        req.adid = responseItem?.adids;
      }
    }
    if (item?.profile?.profileStatus === 'VISIBLE') {
      req.targetCreated = item?.profile?.id;
    }
    out.push(req);
  });
  console.log('out', out);

  return out;
}

export const transformAdidTarget = (data) => {
  const {locations = [], lookupRequests = [], ...targetData} = data;
  const outLocations = [];
  const outInfo = [];

  locations?.filter(loc => loc?.lat && loc?.lng)?.forEach(item => {
    /*outLocations.push({
      id: item?.id,
      info: `
        <div><b>Ip</b>: ${item?.ip}</div>
        <div><b>Country</b>: ${item?.country}</div>
        <div><b>Region</b>: ${item?.region}</div>
        <div><b>Carrier</b>: ${item?.carrier}</div>
        <div><b>Time</b>: ${moment(item?.timestamp).format("DD-MM-YYYY HH:mm:ss")}</div>        
      `,
      lat: item?.lat,
      lng: item?.lng,
    });*/
    outLocations.push(item);
  });

  lookupRequests?.forEach(item => {
    const [lookupRequestItem] = item?.lookupRequestItems;
    if (lookupRequestItem?.rawResponse) {
      const rawResponse = JSON.parse(lookupRequestItem?.rawResponse);
      outInfo.push(rawResponse)
    }
  })


  return {locations: outLocations, adidInfo: outInfo, targetData: targetData};
}